import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';
import { VhsNodeStatus } from '@schema';
import {
  STATUS_ICON_LOADING,
  STATUS_ICON_CHECK_O,
  STATUS_ICON_TIMES_O,
  STATE_ICON_UNASSIGNED,
  STATUS_ICON_WARNING
} from '@/common/utils/statuses';

export const VHS_NODES_STATUS_TEXT = computedLocale<Record<VhsNodeStatus, string>>(() => ({
  [VhsNodeStatus.PROVISIONING]: i18n.t('Provisioning'),
  [VhsNodeStatus.CONFIGURED]: i18n.t('Configured'),
  [VhsNodeStatus.RECONFIGURING]: i18n.t('Reconfiguring'),
  [VhsNodeStatus.DEPROVISIONING]: i18n.t('Deprovisioning'),
  [VhsNodeStatus.ERROR]: i18n.t('Error'),
  [VhsNodeStatus.UNKNOWN]: i18n.t('Unknown'),
  [VhsNodeStatus.MISSING]: i18n.t('Missing')
}));

export const VHS_NODES_STATUS_ICON = computedLocale<Record<VhsNodeStatus, string>>(() => ({
  [VhsNodeStatus.PROVISIONING]: STATUS_ICON_LOADING,
  [VhsNodeStatus.CONFIGURED]: STATUS_ICON_CHECK_O,
  [VhsNodeStatus.RECONFIGURING]: STATUS_ICON_LOADING,
  [VhsNodeStatus.DEPROVISIONING]: STATUS_ICON_LOADING,
  [VhsNodeStatus.ERROR]: STATUS_ICON_TIMES_O,
  [VhsNodeStatus.UNKNOWN]: STATE_ICON_UNASSIGNED,
  [VhsNodeStatus.MISSING]: STATUS_ICON_WARNING
}));
